<svg>
    <use attr.xlink:href="assets/icons.svg#{{ name }}"></use>
</svg>
